<template>
  <v-row wrap class="mt-n3">
    <v-col>
      <v-menu
        v-model="showDatePicker"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ props: menuProps }">
          <v-text-field
            v-model="formattedDate"
            :label="t(label)"
            prepend-icon="mdi-calendar"
            readonly
            variant="outlined"
            v-bind="menuProps"
            :disabled="disabled"
            :error-messages="errorMessages"
            :rules="[required]"
          />
        </template>
        <v-date-picker
          v-model="date"
          @update:model-value="showDatePicker = false"
          first-day-of-week="1"
          locale="de"
          :min="minDate"
          :max="maxDate"
        />
      </v-menu>
    </v-col>
  </v-row>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  parse,
  parseISO,
  format,
  formatISO
} from 'date-fns'
import { required } from '@/utils/validation.js'

const props = defineProps({
  input: [Date, String],
  field: String,
  label: String,
  min: [Date, String],
  max: [Date, String],
  disabled: Boolean,
  errorMessages: [String, Array]
})

const emit = defineEmits(['update:result'])

const { t } = useI18n()

const datetime = ref(null)
const showDatePicker = ref(false)

onMounted(() => {
  setTimeout(() => {
    if (!datetime.value) {
      if (typeof props.input === 'string') {
        datetime.value = parseISO(props.input)
      } else {
        datetime.value = props.input
      }
    } else if (typeof datetime.value === 'string') {
      datetime.value = parseISO(datetime.value)
    }
  }, 500)
})

const defaultTime = computed(() => {
  if (datetime.value) {
    return format(datetime.value, 'HH:mm')
  } else {
    return '00:00'
  }
})

const formattedDate = computed({
  get() {
    if (datetime.value) {
      return format(datetime.value, 'dd.MM.yyyy')
    } else {
      return null
    }
  },
  set(val) {
    return val
  }
})

const minDate = computed(() => {
  if (props.min && props.min instanceof Date) {
    return formatISO(props.min)
  } else {
    return props.min
  }
})

const maxDate = computed(() => {
  if (props.max && props.max instanceof Date) {
    return formatISO(props.max)
  } else {
    return props.max
  }
})

const date = computed({
  get() {
    if (!datetime.value) {
      return format(new Date(), 'yyyy-MM-dd')
    }
    return format(datetime.value, 'yyyy-MM-dd')
  },
  set(newDate) {
    if (!newDate) {
      datetime.value = null
      emit('update:result', null)
    } else {
      returnDate(newDate, defaultTime.value)
    }
  }
})

const returnDate = (dateStr, timeStr) => {
  let newDate
  if (typeof dateStr === 'string') {
    newDate = parse(dateStr, 'yyyy-MM-dd', new Date())
  } else {
    newDate = dateStr
  }
  datetime.value = newDate
  emit('update:result', datetime.value)
}
</script>
